import { AppRouteProps } from "@mzara/component";
import React from "react";

const DetailContractAboutContainer = React.lazy(() => import("./containers/DetailContractAboutContainer"));
export const DetailContractAboutRoute = [
    {
        path: "about",
        element: <DetailContractAboutContainer/>,
        roles: ["PAYING_SLIP"]

    },
] as Array<AppRouteProps>;
